export default __webpack_public_path__ + "static/media/no-photo.98cee0b2.png";